{
  "manager": {
    "userRoles": {
      "assignRole": "Assign Role"
    },
    "mapUserLocationHeatmap": {
      "googleMapsLoadFailed": "Google Maps failed to load"
    },
    "modalCreateUserApiKey": {
      "createApiKey": "Create API Key",
      "keyName": "Key Name",
      "integrationNamePlaceholder": "Integration name",
      "keyNameHelp": "Choose a name to help identify where this key is used.",
      "tokenOnlyOnce": "This is the only time you will see this API key. Copy it now and store it securely.",
      "copiedToClipboard": "Copied to clipboard",
      "tokenSaved": "I have saved the token",
      "apiKeyCreated": "API key created",
      "createError": "Unable to create API key. Please try again."
    },
    "modalDeleteUsers": {
      "deleteUsers": "Delete Users",
      "deleteUser": "Delete User",
      "confirmDeleteUsersPrefix": "Are you sure you want to delete",
      "confirmDeleteUsersSuffix": "user(s)?",
      "confirmDeleteUser": "Are you sure you want to delete this user?",
      "anonymizePersonalData": "Also anonymize personal data",
      "anonymizeWarningStrong": "This will permanently and irreversibly erase all personal information associated with this user",
      "anonymizeWarningBody": ", including their name, email address, phone number, physical address, and linked family members, and replace it with anonymous data. Once anonymized, you will no longer be able to look up this user's account, locate their past invoices, process refunds, or reference any of their historical records.",
      "anonymizeWarningPermanent": "This action is permanent and cannot be undone.",
      "typeAnonymizeToConfirm": "Type ANONYMIZE to confirm",
      "deleteAndAnonymize": "Delete & Anonymize"
    },
    "modalRotateUserApiKey": {
      "confirmRotatePrefix": "Are you sure you want to rotate",
      "rotateWarning": "The existing key will be immediately invalidated. Any integrations using the current key will stop working.",
      "tokenOnlyOnce": "This is the only time you will see this API key. Copy it now and store it securely.",
      "copiedToClipboard": "Copied to clipboard",
      "newApiKey": "New API Key",
      "rotateApiKey": "Rotate API Key",
      "rotateKey": "Rotate Key",
      "apiKeyRotated": "API key rotated",
      "rotateError": "Unable to rotate API key. Please try again."
    },
    "tableUserApiKeys": {
      "createApiKey": "Create API Key"
    },
    "tableUserTransactions": {
      "showMore": "Show more",
      "showLess": "Show less",
      "transactionDetails": "Transaction Details",
      "refund": "Refund",
      "invoice": "Invoice",
      "refundSuccess": "Transaction refunded successfully",
      "refundError": "Failed to refund transaction"
    },
    "inputUserSearch": {
      "searchPlaceholder": "Search by email or name",
      "selectedLabel": "Selected Members:",
      "userId": "User ID:",
      "familyMemberId": "Family Member ID:",
      "createGuestPrompt": "Don't see who you're looking for?",
      "createGuestSignup": "Create Guest Signup",
      "noUsersFound": "No users found for \"{query}\"",
      "guestRegistrationHint": "This will create a guest registration"
    },
    "userBookingsList": {
      "noBookings": "This member does not have any bookings yet."
    },
    "userCustomProfileFieldsEditor": {
      "noCustomFields": "No custom fields."
    },
    "userProfileFieldValueFilter": {
      "selectFieldPlaceholder": "Select field",
      "searchFieldsPlaceholder": "Search fields…",
      "selectValuePlaceholder": "Select value",
      "searchValuesPlaceholder": "Search values…",
      "valuePlaceholder": "Value",
      "removeAriaLabel": "Remove profile field filter",
      "addField": "Add Field",
      "chipMultiple": "{label}: {count} selected"
    },
    "userTypeRadio": {
      "pleaseSelectOne": "Please select one.",
      "guest": "Guest",
      "member": "Member",
      "organization": "Organization"
    },
    "userSearch": {
      "label": "Search users",
      "placeholder": "Enter a search query",
      "searchAriaLabel": "Search"
    },
    "userAdditionalMembers": {
      "addFamilyMember": "Add Family Member",
      "familyMemberUpdated": "Family member updated."
    },
    "userInfo": {
      "personalDetails": "Personal Details",
      "firstName": "First Name",
      "lastName": "Last Name",
      "middleName": "Middle Name",
      "preferredName": "Preferred Name",
      "businessName": "Business Name",
      "password": "Password",
      "change": "Change",
      "profile": "Profile",
      "complete": "Complete",
      "incomplete": "Incomplete",
      "markIncomplete": "Mark incomplete",
      "markComplete": "Mark complete",
      "markIncompleteContext": "Marking this profile incomplete will reset the following so {name} is prompted to complete them again:",
      "theUser": "the user",
      "clearAddress": "Clear their saved address. This cannot be undone.",
      "removeRegistrationForm": "Remove their registration form submission",
      "address": "Address",
      "street": "Street",
      "addressLine2": "Address Line 2",
      "city": "City",
      "provinceState": "Province/State",
      "postalCode": "Postal Code",
      "country": "Country",
      "contact": "Contact",
      "email": "Email",
      "notProvided": "Not provided",
      "phone": "Phone",
      "profileFields": "Profile Fields",
      "filteredCount": "{shown} of {total}",
      "searchFields": "Search fields...",
      "cards": "Cards",
      "list": "List",
      "loadingProfileFields": "Loading profile fields...",
      "noCustomProfileFields": "No custom profile fields have been created.",
      "notSet": "Not set",
      "noFieldsMatch": "No fields match \"{search}\"",
      "clearSearch": "Clear search",
      "fieldName": "Field Name",
      "value": "Value",
      "loadFailed": "Failed to load profile fields. Please refresh the page.",
      "profileField": "Profile Field"
    },
    "userMembershipList": {
      "assignMembership": "Assign Membership",
      "bulkCancel": "Bulk Cancel",
      "paymentFailed": "Payment failed (attempt {count}/3)",
      "nextAttempt": "Next attempt:",
      "updatePaymentMethod": "User needs to update payment method",
      "cancelMemberships": "Cancel memberships",
      "confirmBulkCancel": "Are you sure you want to cancel {count} selected membership(s)? This will end the subscription(s) and cannot be undone.",
      "expirationUpdated": "Membership expiration updated",
      "membershipsCancelled": "Memberships cancelled",
      "cancelFailed": "Failed to cancel memberships",
      "membershipsMoving": "Memberships will be moved, this can take up to 10 minutes.",
      "genericError": "Something went wrong. Please contact support.",
      "providedBy": "Provided by {name}"
    },
    "userNotes": {
      "createANote": "Create a note",
      "noNotesCreated": "No notes created.",
      "editNote": "Edit Note",
      "note": "Note"
    },
    "userSnapshot": {
      "userSnapshot": "User snapshot",
      "active": "Active",
      "inactive": "Inactive",
      "memberships": "Memberships",
      "noMembershipsFound": "No memberships found.",
      "loadingData": "Loading data"
    },
    "userTags": {
      "assignTag": "Assign Tag",
      "user": "User",
      "tags": "Tags",
      "selectOneOrMore": "Select one or more",
      "tagsSelected": "{count} tags selected"
    },
    "userVolunteerShifts": {
      "activeSignups": "Active Signups",
      "cancelledSignups": "Cancelled Signups",
      "entityVolunteerSignup": "Volunteer signup"
    },
    "userWaiverAgreements": {
      "waiver": "Waiver",
      "agreementDate": "Agreement Date"
    },
    "simpleMemberSearch": {
      "searchPlaceholder": "Search by email or name",
      "selectedMembers": "Selected Members:"
    },
    "userFiles": {
      "files": "Files",
      "upload": "Upload"
    },
    "userLocationHeatmap": {
      "title": "User Location Heatmap",
      "intro": "This heatmap shows where your users are located geographically. Use this to help plan marketing and outreach.",
      "googleMapsDisabled": "Google Maps is disabled for this organization. Please enable it in your settings to use this feature.",
      "noLocations": "No user locations available to display.",
      "noLocationsHint": "Users need complete address information to appear on the map.",
      "showingUsers": "Showing {geocoded} of {total} users",
      "skippedUsers": "({count} users could not be geocoded)",
      "sessionExpired": "Your session has expired. Please refresh the page and log in again.",
      "noPermission": "You do not have permission to view user locations.",
      "serverError": "The server encountered an error. Please try again later.",
      "loadFailed": "Failed to load user locations. Please try again or contact support."
    },
    "userImport": {
      "uploadCsvFileTitle": "Upload CSV File",
      "uploadCsvFileDescription": "Upload a CSV file containing user data. The first row should contain column headers.",
      "selectCsvFile": "Select CSV File",
      "maxFileSizeDescription": "Maximum file size is 10MB. CSV files only.",
      "maxFileSizeFeedback": "The maximum file size is 10MB. Please split up the file if it's too large.",
      "csvFilePlaceholder": "Choose a CSV file or drop it here...",
      "csvFileDropPlaceholder": "Drop CSV file here...",
      "fileLoaded": "File loaded:",
      "columnsRowsDetected": "{columns} columns, {rows} rows detected",
      "nextMapFields": "Next: Map Fields",
      "mapColumnsTitle": "Map CSV Columns to User Fields",
      "mapColumnsDescription": "Match your CSV columns to the appropriate user fields. Required fields are marked with an asterisk.",
      "csvBadge": "CSV",
      "selectCsvColumn": "-- Select CSV Column --",
      "selectUserField": "-- Select User Field --",
      "userField": "User Field",
      "fieldTypesGuide": "Field Types Guide",
      "userPropertiesLabel": "User Properties:",
      "userPropertiesDescription": "Direct user fields like name, email, phone",
      "createSubscriptionLabel": "Create Subscription:",
      "createSubscriptionDescription": "Format: plan_id{'|'}expiration_date{'|'}auto_renew (e.g., \"gold{'|'}2024-12-31{'|'}true\")",
      "createTagLabel": "Create Or Update Tag:",
      "createTagDescription": "Tag name to assign to the user",
      "customProfileFieldLabel": "Custom Profile Field:",
      "customProfileFieldDescription": "Custom field values",
      "familyMemberNameLabel": "Family Member Name:",
      "familyMemberNameDescription": "Additional family member to create",
      "createNoteLabel": "Create Note:",
      "createNoteDescription": "Note content to add to user record",
      "resetConfiguration": "Reset Configuration",
      "nextPreview": "Next: Preview",
      "previewImportTitle": "Preview Import Data",
      "previewImportDescription": "Review the first 20 rows to verify your field mappings are correct before validation.",
      "noPreviewData": "No preview data available. Please check your CSV file and mappings.",
      "uploading": "Uploading...",
      "validating": "Validating...",
      "validateData": "Validate Data",
      "validationFailed": "Validation Failed -",
      "error": "Error",
      "found": "Found",
      "row": "Row",
      "fixErrorsInstruction": "Please fix these errors in your CSV file and try again.",
      "importStatistics": "Import Statistics",
      "validationSuccessful": "Validation Successful!",
      "validationSuccessMessage": "All data has been validated successfully. Your import is ready to be processed.",
      "totalRowsLabel": "Total rows:",
      "fieldsMappedLabel": "Fields mapped:",
      "continueToImport": "Continue to Import",
      "readyToImportTitle": "Ready to Import",
      "readyToImportSubtitle": "Your import has been validated and is ready to process!",
      "processInBackground": "Click the button below to queue the import. The system will process all {count} rows in the background.",
      "totalUsers": "Total Users",
      "mappedFields": "Mapped Fields",
      "statusReady": "Ready",
      "statusLabel": "Status",
      "processing": "Processing...",
      "startImport": "Start Import",
      "startOver": "Start Over",
      "noteLabel": "Note:",
      "largeImportNote": "Large imports are processed in the background. You'll receive a notification when the import is complete.",
      "confirmImportTitle": "Confirm Import",
      "confirmImportMessage": "Are you sure you want to import {count} users? This action cannot be undone.",
      "yesImport": "Yes, Import",
      "pageTitle": "User Import",
      "stepUploadCsv": "Upload CSV",
      "stepMapFields": "Map Fields",
      "stepPreviewValidate": "Preview & Validate",
      "stepDispatch": "Dispatch",
      "csvColumnLabel": "CSV Column",
      "descriptionLabel": "Description",
      "columnHeader": "Column",
      "errorMessageHeader": "Error Message",
      "toastValidateSuccess": "Import validated successfully! You may now queue the import.",
      "toastValidateFailed": "Validation failed. Please review the errors below.",
      "toastUploadError": "An error occurred during upload or validation.",
      "toastDispatchSuccess": "Import has been queued successfully! You will be notified when it completes.",
      "toastDispatchError": "Failed to queue import. Please try again.",
      "previewSubscription": "Plan: {planId}, Expires: {expirationDate}",
      "previewTag": "Tag: {value}",
      "infoCreateSubscription": "Format: plan_id{'|'}expiration_date{'|'}auto_renew",
      "infoCreateTag": "Tag name to assign to user",
      "infoCustomProfileField": "Custom field value",
      "infoFamilyMemberName": "Additional family member name",
      "infoCreateNote": "Note content for user record",
      "infoEmailFormat": "Must be valid email format",
      "pluralSuffix": "s"
    },
    "userCreate": {
      "personalInformation": "Personal Information",
      "firstNameLabel": "First Name *",
      "fieldRequired": "This field is required.",
      "firstNamePlaceholder": "Enter a first name",
      "lastNameLabel": "Last Name *",
      "lastNamePlaceholder": "Enter a last name",
      "middleNameLabel": "Middle Name",
      "middleNamePlaceholder": "Enter a middle name",
      "preferredNameLabel": "Preferred Name",
      "preferredNamePlaceholder": "Enter a preferred name",
      "businessNameLabel": "Business Name",
      "businessNamePlaceholder": "Enter a business name associated with user",
      "accountDetails": "Account Details",
      "emailLabel": "Email *",
      "emailPlaceholder": "Enter a valid email address",
      "customMemberIdLabel": "Custom Member ID",
      "customMemberIdDescription": "Leave blank unless assigning a custom ID.",
      "passwordHint": "If no password is specified, the user will be sent an email with steps on how to set their own password.",
      "contactInformation": "Contact Information",
      "phoneNumberLabel": "Phone Number",
      "userProfileRequirements": "User Profile Requirements",
      "profileRequirementsInfo": "Users must complete their profile before accessing member features. The profile completion step is skipped only when a password is provided and profile requirements are not enabled.",
      "profileRequirementsNote": "Note that this only applies to new users. Existing users will not be forced to retroactively complete their profile.",
      "addressLabel": "Address",
      "requireAddress": "Require user to enter an address",
      "registrationFormLabel": "Registration Form",
      "requireRegistrationForm": "Require user to complete the registration form",
      "noRegistrationForm": "No registration form has been created for this tenant. Create one in the",
      "formsLinkText": "Forms",
      "formsSection": "section.",
      "saveAndCreateAnother": "Save & Create Another",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "emailRequired": "Email is required",
      "validEmail": "Please enter a valid email",
      "editUser": "Edit User",
      "createUser": "Create User",
      "entityUser": "User",
      "saveFailed": "Failed to save user. Please try again.",
      "userNotFound": "User not found.",
      "loadFailed": "Failed to load user. Please try again.",
      "pageTitle": "Create User"
    },
    "userIndex": {
      "title": "Users",
      "assignTag": "Assign Tag",
      "assignRole": "Assign Role",
      "sendMemberCard": "Send Member Card",
      "selectEmailsLabel": "Select the emails you would like to receive this card:",
      "emailRequiredFeedback": "Please select at least one email or select 'Other' and enter an email address",
      "otherEmailLabel": "Other Email",
      "emailPlaceholder": "Enter an email address",
      "all": "All",
      "subscribed": "Subscribed",
      "unsubscribed": "Unsubscribed",
      "entityUser": "User",
      "deleteUsersFailed": "Error deleting users. Try again later or contact support.",
      "usersDeletedAnonymizing": "Users deleted. Anonymization is processing.",
      "usersDeleted": "Users deleted",
      "memberCardSent": "Member card sent",
      "memberCardFailed": "Error sending member card",
      "organizationFilter": "Organization",
      "myOrganization": "My Organization",
      "membershipFilter": "Membership",
      "planFilter": "Plan",
      "tagsFilter": "Tags",
      "rolesFilter": "Roles",
      "emailStatusFilter": "Email Status",
      "profileFieldsFilter": "Profile Fields",
      "other": "Other",
      "groupOwner": "Group owner",
      "linkedUser": "Linked user",
      "accountTypeFilter": "Account Type",
      "removeTag": "Remove Tag",
      "removeTagsLabel": "Tags to remove",
      "removeTagsPlaceholder": "Pick tags to remove",
      "removeTagsInvalid": "Pick at least one tag to remove.",
      "removeTagsEmpty": "None of the selected users have tags to remove.",
      "oneUser": "1 user",
      "manyUsers": "{count} users",
      "removeTagsTitle": "Remove tags from {users}",
      "removeTagsContext": "Pick which tags to remove from the selected {users}. Users without a selected tag are skipped.",
      "removingTags": "Removing...",
      "remove": "Remove",
      "removeOneTag": "Remove 1 tag",
      "removeManyTags": "Remove {count} tags",
      "oneTagRemoved": "1 tag removed from {users}",
      "manyTagsRemoved": "{count} tags removed from {users}",
      "removeTagsFailed": "Failed to remove tags. Please try again."
    },
    "userShow": {
      "notFoundTitle": "User Not Found",
      "notFoundMessage": "This user doesn't exist or may have been deleted.",
      "notFoundLinkText": "Back to Users",
      "memberId": "Member ID:",
      "accountCreated": "Account created",
      "moreActions": "More Actions",
      "viewMemberCard": "View Member Card",
      "impersonate": "Impersonate",
      "changePassword": "Change Password",
      "sendResetEmail": "Send Reset Email",
      "pageTitle": "View User",
      "userDeletedAnonymizing": "User deleted. Anonymization is processing.",
      "userDeleted": "User deleted",
      "deleteFailed": "Failed to delete user. Try again later or contact support.",
      "passwordUpdated": "Password has been updated!",
      "notesRefreshFailed": "Failed to refresh notes. Please reload the page.",
      "loadFailed": "Failed to load user. Please reload the page."
    },
    "guestOrMember": {
      "guest": "Guest",
      "member": "Member",
      "organization": "Organization",
      "fullNameLabel": "Full Name *",
      "fieldRequired": "This field is required.",
      "enterName": "Enter a name",
      "emailLabel": "Email *",
      "enterGuestEmail": "Enter an email for the guest",
      "telephoneLabel": "Telephone",
      "enterPhone": "Enter a phone number",
      "searchOrganization": "Search for an organization",
      "recipientRequired": "A invoice recipient is required",
      "userRequired": "User is required",
      "organizationRequired": "Organization is required",
      "guestNameRequired": "Guest name is required",
      "guestEmailRequired": "Guest email is required"
    },
    "assignMembershipModal": {
      "title": "Assign Membership",
      "selectMembership": "Select Membership",
      "selectPlan": "Select Plan",
      "paymentMethod": "Payment Method",
      "paymentMethodDescription": "If the user paid for this membership, you can specify the payment method they used.",
      "selectMethodPlaceholder": "Select method...",
      "amountPaid": "Amount Paid",
      "amountPaidDescription": "If the user paid for this membership, you can specify the amount they paid.",
      "dateOfPurchase": "Date of Purchase",
      "dateOfPurchaseDescription": "Used for the transaction list date only.",
      "sendEmailNotification": "Send user an email notifying them a membership has been assigned",
      "includeReceipt": "Include a transaction receipt in email",
      "freeLifetime": "Free Lifetime",
      "membershipAssigned": "Membership assigned!"
    },
    "assignRoleModal": {
      "title": "Assign Role",
      "selectRole": "Select Role *",
      "roleRequired": "A role selection is required."
    },
    "assignTagModal": {
      "title": "Assign Tag",
      "selectTag": "Select Tag *",
      "tagRequired": "A tag selection is required.",
      "searchPlaceholder": "Search for a tag"
    },
    "changePasswordModal": {
      "title": "Change Password",
      "changeFailed": "Failed to change password. Please try again."
    },
    "triggerPasswordReset": {
      "title": "Trigger Password Reset Email",
      "body": "This will send a password reset email to the user selected. The user will then have the ability to reset their password.",
      "triggerEmail": "Trigger email",
      "resetTriggered": "Password reset triggered!",
      "resetFailed": "Failed to send password reset email. Please try again."
    },
    "customProfileFieldCreate": {
      "nameLabel": "Name *",
      "displayOnMembershipCardLabel": "Display on Membership Card",
      "displayOnMembershipCardHelp": "If checked, this field will be added to the membership card.",
      "allowUsersToEditLabel": "Allow users to edit",
      "allowUsersToEditHelp": "If checked, users will be allowed to edit this field on their profile.",
      "forChildTenantsDescription": "If checked, this field will be added as a locked profile field to all child tenants.",
      "addFieldToChildTenants": "Add this field to child tenants",
      "editFieldHeader": "Edit Field",
      "createFieldHeader": "Create Field",
      "entity": "Profile Field",
      "pageTitle": "Create Custom Profile Field"
    },
    "customProfileFieldIndex": {
      "title": "Profile Fields",
      "viewReport": "View Report"
    },
    "customProfileFieldReport": {
      "backToProfileFields": "Back to Profile Fields",
      "pageTitle": "Profile Field Report",
      "description": "See how users have responded to profile fields. Shows the most common values entered for each field.",
      "tryAgain": "Try Again",
      "noFieldsFound": "No profile fields found.",
      "emptyValue": "(empty)",
      "noValuesRecorded": "No values recorded for this field.",
      "allFields": "All Fields",
      "fieldFilterSingle": "Field: {name}",
      "unknownField": "Unknown",
      "fieldsSelected": "{count} Fields Selected",
      "valueColumn": "Value",
      "countColumn": "Count",
      "distributionColumn": "Distribution",
      "loadFieldsError": "Failed to load profile fields. Please refresh the page.",
      "loadSummaryError": "Failed to load profile field summary. Please try again.",
      "loadSummaryErrorToast": "Failed to load profile field summary."
    },
    "familyMembersIndex": {
      "makeGroupOwner": "Make group owner",
      "groupOwnerReassigned": "Group owner reassigned.",
      "reassignGroupOwnerTitle": "Reassign Group Owner",
      "reassignGroupOwnerText": "This makes the selected confirmed member the new group owner.",
      "reassign": "Reassign",
      "columnId": "ID",
      "columnMember": "Member",
      "columnEmail": "Email",
      "columnStatus": "Status",
      "searchLabel": "Search",
      "searchPlaceholder": "Search member name, email, or business"
    },
    "membershipList": {
      "title": "User Memberships",
      "refresh": "Refresh",
      "moveMembership": "Move Membership",
      "bulkCancel": "Bulk Cancel",
      "paymentFailedAttempt": "Payment failed (attempt {count}/3)",
      "nextAttempt": "Next attempt:",
      "userNeedsUpdatePayment": "User needs to update payment method",
      "cancelMemberships": "Cancel memberships",
      "bulkCancelConfirm": "Are you sure you want to cancel {count} selected membership(s)? This will end the subscription(s) and cannot be undone.",
      "organizationFilter": "Organization",
      "all": "All",
      "moveError": "Something went wrong. Please contact support.",
      "membershipsMoving": "Memberships will be moved, this can take up to 10 minutes.",
      "expirationUpdated": "Membership expiration updated",
      "membershipsCancelled": "Memberships cancelled",
      "cancelFailed": "Failed to cancel memberships"
    },
    "roleCreate": {
      "roleDetails": "Role Details",
      "nameLabel": "Name *",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter the name of the role",
      "volunteerRole": "Role is a volunteer role",
      "role": "Role",
      "pageTitle": "Create Role"
    },
    "roleIndex": {
      "title": "Roles",
      "pageTitle": "User Roles"
    }
  },
  "user": {
    "userTags": {
      "communityNeedsYou": "Your community needs YOU!",
      "nextStep": "Next step"
    },
    "familyMemberList": {
      "selectMemberHeader": "Select a member from the list:",
      "select": "Select",
      "missingSomeone": "Missing someone?",
      "addNewMemberLink": "Click here to add a new member"
    },
    "completeYourProfile": {
      "title": "Complete Your Profile",
      "passwordStep": "Step {number}: Set your password.",
      "addressStep": "Step {number}: Add your address.",
      "registrationStep": "Step {number}: Complete the registration form."
    }
  }
}
